import React, { createContext, useContext } from 'react';

/** When true (analyst role): view fleet only — no add/rename/delete drone, no maintenance adjustments. */
const FleetLimitedAccessContext = createContext(false);

export const FleetLimitedAccessProvider: React.FC<{
  value: boolean;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <FleetLimitedAccessContext.Provider value={value}>
    {children}
  </FleetLimitedAccessContext.Provider>
);

export function useFleetLimitedAccess(): boolean {
  return useContext(FleetLimitedAccessContext);
}
